import queryString from 'querystring';
import throttle from 'lodash.throttle';

import {loadNative} from 'utils/dynamicLoader';

const setupSelected = (groupNode) => {
    const items = [
        ...groupNode.querySelectorAll('.facet--item input[type="checkbox"]:checked'),
    ];

    if (items.length > 0) {
        const facetItem = items[items.length - 1].parentElement.parentElement;
        facetItem.classList.add('selected');
        facetItem.parentNode.classList.add('has-selected');
    }
};


const filterMatching = (groupNode, filter) => {
    const items = [...groupNode.querySelectorAll('.facet--item')];

    const filterFunc = title => (
        !filter ||
        (filter && filter.trim().length === 0) ||
        title.toLocaleLowerCase().includes(filter.trim().toLocaleLowerCase())
    );

    items.forEach((item) => {
        const title = item.querySelector('label').title;

        if (filterFunc(title)) {
            item.classList.remove('hide');
        } else {
            item.classList.add('hide');
        }
    });
};

const setupFacetFiltering = (groupNode) => {
    const filterBox = groupNode.querySelector('.filters-facet-search');
    const callBack = throttle((evt) => {
        filterMatching(groupNode, evt.target.value);
    }, 100);

    filterBox.addEventListener('keyup', callBack);
};


const setupGroupNode = (groupNode) => {
    setupSelected(groupNode);
    setupFacetFiltering(groupNode);
};

const setupFacetParameters = () => {
    const searchForms = [
        document.querySelector('.filter-group.search > form'),
        document.querySelector('form.products-filters'),
    ];

    let selectedFacets = queryString.parse(window.location.search.substr(1)).selected_facets;
    if (!selectedFacets) {
        return;
    }

    // selectedFacets can be string (if there was just one of them) or array
    if (typeof selectedFacets.forEach !== 'function') {
        selectedFacets = [selectedFacets];
    }
    // Remove duplicates
    selectedFacets = [...new Set(selectedFacets)];

    if (!selectedFacets) {
        return;
    }

    const applyFacet = (facet, searchForm) => {
        const input = document.createElement("input");
        input.name = 'selected_facets';
        input.type = 'hidden';
        input.value = facet;
        searchForm.appendChild(input);
    };

    searchForms.forEach((searchForm) => {
        selectedFacets.forEach(facet => applyFacet(facet, searchForm));
    });
};


const setupPaginateBy = () => {
    const formElement = document.querySelector('form.products-filters');
    const paginateSelect = document.querySelector('#id_paginate_by');

    if (!paginateSelect || !formElement) {
        return;
    }

    paginateSelect.addEventListener('change', () => {
        const input = document.createElement("input");
        input.name = 'page';
        input.type = 'hidden';
        input.value = '1';
        formElement.appendChild(input);
        formElement.submit();
    });
};


export default () => {
    const groupNodes = document.querySelectorAll('.facet--group');

    [...groupNodes].forEach((groupNode) => {
        loadNative(() => setupGroupNode(groupNode));
    });

    loadNative(setupFacetParameters);
    loadNative(setupPaginateBy);
};



// WEBPACK FOOTER //
// ./src/widgets/FacetGroups.js